export const getLoggedInStatus = () => {
    const { TaplakLoggedIn, taplakToken } = localStorage

    // Create logic of verifying login session using bearer token
    if (TaplakLoggedIn && taplakToken) {
        return true
    }
    return false
}